// Batch 32 · Part 5 LOW items (fork F): document types (S6), Other Information "not obtained" (S10), Document Review files
// not added (T7), the currency ISO hint, and the Audit Trail labels of the holiday / working-hours rows, EN + AR.
// Merged into lib/i18n.js translations (big-file rule: new strings in their own file).
export const I18N_B32F = {
  en: {
    b32f: {
      docsNotAdded: "{n} file(s) not added — only PDF and images here; spreadsheets go to Head folders (the head's lead sheet or worksheet attachments).",
      oiNoConclusion: "No conclusion yet — the auditor's report cannot be generated until one of the options below is chosen.",
      currencyUseIso: "Use the ISO code {code}.",
    },
    docs: { types: { engagement_letter: "Engagement letter", financial_statements: "Financial statements" } },
    docFields: {
      letter_date: "Letter date", entity_name: "Entity", addressee: "Addressed to", framework: "Financial reporting framework",
      fee: "Fee", has_signature: "Signed / stamped", total_assets: "Total assets", total_equity: "Total equity",
      profit_for_period: "Profit for the period",
    },
    oi: { conc_not_obtained: "No other information obtained" },
    engLocale: {
      otherInvalid: "The currency must be 1 to 10 characters, without < or >. Use the 3-letter ISO code (for example SAR).",
    },
    errors: {
      ENGAGEMENT_CURRENCY_INVALID: "The currency must be 1 to 10 characters, without < or >. Use the 3-letter ISO code (for example SAR).",
    },
    w13: {
      action: {
        engagement_holidays_changed: "Public holidays changed",
        engagement_working_hours_changed: "Working hours changed",
      },
    },
  },
  ar: {
    b32f: {
      docsNotAdded: "لم يُضف {n} ملف — هنا ملفات PDF والصور فقط؛ تُرفع جداول البيانات في مجلدات البنود (مرفقات الورقة الرئيسية للبند أو ورقة العمل).",
      oiNoConclusion: "لم يُختر استنتاج بعد — يُمنع إنشاء تقرير المدقق حتى يُختار أحد الخيارات أدناه.",
      currencyUseIso: "استخدم رمز ISO {code}.",
    },
    docs: { types: { engagement_letter: "خطاب الارتباط", financial_statements: "القوائم المالية" } },
    docFields: {
      letter_date: "تاريخ الخطاب", entity_name: "المنشأة", addressee: "موجّه إلى", framework: "إطار التقرير المالي",
      fee: "الأتعاب", has_signature: "موقّع / مختوم", total_assets: "إجمالي الأصول", total_equity: "إجمالي حقوق الملكية",
      profit_for_period: "ربح الفترة",
    },
    oi: { conc_not_obtained: "لم يتم الحصول على معلومات أخرى" },
    engLocale: {
      otherInvalid: "يجب أن تتكون العملة من 1 إلى 10 أحرف، دون < أو >. استخدم رمز ISO المكوّن من 3 أحرف (مثل SAR).",
    },
    errors: {
      ENGAGEMENT_CURRENCY_INVALID: "يجب أن تتكون العملة من 1 إلى 10 أحرف، دون < أو >. استخدم رمز ISO المكوّن من 3 أحرف (مثل SAR).",
    },
    w13: {
      action: {
        engagement_holidays_changed: "تغيير العطل الرسمية",
        engagement_working_hours_changed: "تغيير ساعات العمل",
      },
    },
  },
};

export default I18N_B32F;
